import { useEffect, useRef, useState } from "react";
import { EDITORIAL_MARQUEE, INTERIOR_MARQUEE } from "@/lib/photos";
import ResponsiveImage from "./ResponsiveImage";

const rowOne = [...EDITORIAL_MARQUEE, ...EDITORIAL_MARQUEE];
const rowTwo = [...INTERIOR_MARQUEE];

export default function EditorialScroller() {
  // P1F: the marquee is decorative and well below the fold, yet its first
  // tiles (q7uje42u ~ , mdesfgc5 ~) were proven to fetch during the initial
  // mobile session. Gate ALL marquee media behind a single section-level
  // IntersectionObserver so nothing downloads until the section approaches the
  // viewport. Gating the whole section (not per-tile) avoids horizontal
  // pop-in as the marquee animates tiles into view.
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { setInView(true); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setInView(true); io.disconnect(); }
    }, { rootMargin: "300px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 md:py-28 overflow-hidden bg-ivory-100 relative" data-testid="editorial-scroller">
      <div className="container-editorial mb-10 md:mb-14">
        <p className="overline mb-3">The Vanturis Collection</p>
        <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight text-ink max-w-3xl">
          Every coach we present has a story worth telling.
        </h2>
      </div>

      {/* Row 1 — left to right */}
      <div className="relative mb-6">
        <div className="flex gap-6 w-max" style={{ animation: "vanturis-marquee-left 80s linear infinite" }}>
          {rowOne.map((src, i) => (
            <div key={`m1-${i}`} className="w-[420px] md:w-[560px] aspect-[16/10] overflow-hidden flex-shrink-0 bg-ivory-200">
              {inView && <ResponsiveImage src={src} alt="" loading="lazy" maxWidth={960} sizes="(max-width: 768px) 420px, 560px" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[900ms]" />}
            </div>
          ))}
        </div>
      </div>

      {/* Row 2 — right to left, interiors */}
      <div className="relative">
        <div className="flex gap-6 w-max" style={{ animation: "vanturis-marquee-right 90s linear infinite" }}>
          {rowTwo.map((src, i) => (
            <div key={`m2-${i}`} className="w-[340px] md:w-[460px] aspect-[16/10] overflow-hidden flex-shrink-0 bg-ivory-200">
              {inView && <ResponsiveImage src={src} alt="" loading="lazy" maxWidth={960} sizes="(max-width: 768px) 340px, 460px" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[900ms]" />}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes vanturis-marquee-left  { 0% { transform: translateX(0); }    100% { transform: translateX(-50%); } }
        @keyframes vanturis-marquee-right { 0% { transform: translateX(-50%); } 100% { transform: translateX(0); } }
      `}</style>
    </section>
  );
}
